// extracted by mini-css-extract-plugin
export default {"specialOffer":"PD1ng","coin":"nvv3l","credits":"OY_c8","priceContainer":"HDBJm","price":"GCvYJ","originalPrice":"uv9R5","image":"JeBbX","mobile":"_poBT","tablet":"rkrHZ"};